import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { GrantLicenseModes } from './SyncActiveDirectoryGroupRequest';

export interface IUpdateGroupsMinimumSiteRoleParams {
  groupIds: string[];
  minimumSiteRole: string; // See SiteRoles for possible values. Currently 'ServerAdministrator' and 'Guest' are not allowed.
  grantLicenseMode: GrantLicenseModes;
}

export class UpdateGroupsMinimumSiteRoleRequest extends Request<IUpdateGroupsMinimumSiteRoleParams, IResult> {
  constructor(params: IUpdateGroupsMinimumSiteRoleParams) {
    super('updateGroupsMinimumSiteRole', params);
  }
}
